import { FinancialServiceProviderAdapters } from '@seapoint/server/enums';
import { InstitutionView } from '../../../types/entity-types';

import logoStripe from '../../../assets/images/logo-stripe.svg';

/**
 * Maps provider types to their local logo assets.
 * Add new providers here when their logos are added to assets/images/
 */
const PROVIDER_LOGO_MAP: Partial<Record<FinancialServiceProviderAdapters, string>> = {
  [FinancialServiceProviderAdapters.STRIPE]: logoStripe,
};

/**
 * Get the logo URL for an institution.
 * If the institution has a known provider type with a local asset, returns the local asset path.
 * Otherwise, returns the CDN URL from the institution data.
 */
function getInstitutionLogo(institution: InstitutionView): string {
  const provider = institution.provider as FinancialServiceProviderAdapters | undefined;
  if (provider && PROVIDER_LOGO_MAP[provider]) {
    return PROVIDER_LOGO_MAP[provider]!;
  }
  return institution.logo;
}

export type InstitutionDetails = {
  logo: string;
  name: string;
};

/**
 * Get display details for an institution.
 * Resolves the logo to a local asset if the provider is known.
 */
export function getInstitutionDetails(institution: InstitutionView): InstitutionDetails {
  return {
    logo: getInstitutionLogo(institution),
    name: institution.name,
  };
}
